import { render, staticRenderFns } from "./m-audio-skeleton.vue?vue&type=template&id=15646ca8&scoped=true"
import script from "./m-audio-skeleton.vue?vue&type=script&lang=js"
export * from "./m-audio-skeleton.vue?vue&type=script&lang=js"
import style0 from "./m-audio-skeleton.vue?vue&type=style&index=0&id=15646ca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15646ca8",
  null
  
)

export default component.exports